import {
  Source,
  SourceDocument,
  Sources,
  SourcesContent,
  SourcesTrigger,
} from '@crowdex/ui/ai/sources';
import type { SourcePart } from '@/lib/conversations/message-part/types';

function sourceLabel(part: SourcePart): string {
  if (part.type === 'source-document') return part.title || part.filename || part.sourceId;
  try {
    const url = new URL(part.url);
    return url.hostname || part.url;
  } catch {
    return part.url;
  }
}

/** Renders the AI SDK's native source parts as one compact AI Elements group. */
export function MessageSources({ parts }: { parts: readonly SourcePart[] }) {
  return (
    <Sources>
      <SourcesTrigger count={parts.length} />
      <SourcesContent>
        {parts.map((part) =>
          part.type === 'source-url' ? (
            <Source href={part.url} key={`${part.sourceId}:${part.url}`}>
              {sourceLabel(part)}
            </Source>
          ) : (
            <SourceDocument key={`${part.sourceId}:${part.title}`}>
              <span className="min-w-0 flex-1 truncate">{sourceLabel(part)}</span>
              <span className="shrink-0 uppercase">{part.mediaType.split('/').at(-1)}</span>
            </SourceDocument>
          ),
        )}
      </SourcesContent>
    </Sources>
  );
}
